export const SUPPORTED_INTEGRATIONS = [
	'binance',
	'binanceus',
	'bitfinex',
	'bitbuy',
	'bittrex',
	'bitvavo',
	'blockchaincom',
	'celsius',
	'coinbase',
	'coinbasepro',
	'coindcx',
	'coinspot',
	'coinsquare',
	'cointracking',
	//'cryptocom',
	'dash',
	'exodus',
	'etoro',
	'ftx', // 1
	'ftxus', // 2
	'gateio',
	'gemini',
	'kraken',
	//'kucoin',
	'ndax',
	'newton',
	'poloniex',
	'shakepay',
	'trustwallet',
	'wealthsimplecrypto',
	'wazirx',
	'bitmart',
	'bybit',
	'huobi',
	'mexcglobal', // 3
	'okx',
	'wavesexchange',
	'bitrue',
	'ascendex',
	'bitso',
	'upbit',
	'bitstamp',
	'walletconnect', // 4
]
